import { gql } from "@apollo/client"

const UPDATE_SB_ACCOUNT_LINK_MUTATION = gql`
  mutation($input: UpdateSbAccountLinkInput!) {
    updateSbAccountLink(input: $input) {
      id
      email
    }
  }
`

export { UPDATE_SB_ACCOUNT_LINK_MUTATION }